import {Subject} from "rxjs";
import {BusinessDto, MenuDto, RevisionDto} from "../gen/client";

export const businessSubject = new Subject<BusinessDto>();

export const menuSubject = new Subject<MenuDto>();

export const saveRevisionSubject = new Subject<RevisionDto>();
